import * as dto from "../../common/models/rules.model";


export default class RuleTreeBuilder{

    arg(name:string):dto.ArgumentNode{
        return {
            nodeType:dto.NodeKind.ArgumentNode,
            name:name
        };
    }
    public _mathOps:string="+-*/%";
    math(lhs:dto.LunaCodeNode, op:string, rhs:dto.LunaCodeNode):dto.ArithmeticNode{
        if(this._mathOps.indexOf(op) < 0) throw new Error(`undefined operation ${op}`);
        return {
            nodeType:dto.NodeKind.ArithmeticNode,
            lhs:lhs,
            rhs:rhs,
            operation:op
        };
    }
    add(lhs:dto.LunaCodeNode, rhs:dto.LunaCodeNode):dto.ArithmeticNode{
        return this.math(lhs,"+",rhs);
    }
    sub(lhs:dto.LunaCodeNode, rhs:dto.LunaCodeNode):dto.ArithmeticNode{
        return this.math(lhs,"-",rhs);
    }
    mul(lhs:dto.LunaCodeNode, rhs:dto.LunaCodeNode):dto.ArithmeticNode{
        return this.math(lhs,"*",rhs);
    }
    div(lhs:dto.LunaCodeNode, rhs:dto.LunaCodeNode):dto.ArithmeticNode{
        return this.math(lhs,"/",rhs);
    }
    mod(lhs:dto.LunaCodeNode, rhs:dto.LunaCodeNode):dto.ArithmeticNode{
        return this.math(lhs,"%",rhs);
    }
    true():dto.BooleanLiteral{
        return {
            nodeType:dto.NodeKind.BooleanLiteral,
            value : true
        };
    }
    false():dto.BooleanLiteral{
        return {
            nodeType:dto.NodeKind.BooleanLiteral,
            value : false
        };
    }
    null():dto.NullLiteral{
        return this.literal(null) as dto.NullLiteral;
    }
    
    literal(obj:any):dto.LiteralNode{
        
        let objType:string = typeof obj;
        if(obj === null || obj === undefined){
            return {
                nodeType:dto.NodeKind.NullLiteral,
                value:null,
            };
        }
        else if(obj instanceof Boolean || objType === "boolean"){
            return {
                nodeType:dto.NodeKind.BooleanLiteral,
                value : obj as boolean
            };
        }
        else if(obj instanceof Date || objType === "date") {
            return {
                nodeType:dto.NodeKind.DateLiteral,
                value : obj as Date
            };
        }
        else if(obj instanceof Number || objType === 'number'){
            return {
                nodeType:dto.NodeKind.NumberLiteral,
                value : obj as Number
            };            
        }
        else if (obj instanceof String || (objType ==='string')){
            return {
                nodeType:dto.NodeKind.StringLiteral,
                value : obj as string
            };
        }
        else{
            throw new Error(`Unable to cooerce ${obj} (${objType}) into a String, Guid, Date, Number, or Null`)
        }

    }
    logic(lhs:dto.LunaCodeNode, op:string, rhs:dto.LunaCodeNode) : dto.LunaCodeNode{
        if((op === "==" ||op ==="=")){
            if(lhs.nodeType === dto.NodeKind.NullLiteral){
                return this.isNull(rhs);
            }
            else if (rhs.nodeType === dto.NodeKind.NullLiteral){
                return this.isNull(lhs);
            }
        }
        if((op === "!=" ||op ==="<>")){
            if(lhs.nodeType === dto.NodeKind.NullLiteral){
                return this.isNotNull(rhs);
            }
            else if (rhs.nodeType === dto.NodeKind.NullLiteral){
                return this.isNotNull(lhs);
            }
        }        
        return{
            nodeType:dto.NodeKind.BooleanLogicNode,
            lhs:lhs,
            operation:op,
            rhs:rhs
        } as dto.BooleanLogicNode;
    }
    eq(lhs:dto.LunaCodeNode, rhs:dto.LunaCodeNode) : dto.LunaCodeNode{
        return this.logic(lhs,"==",rhs);
    }
    ne(lhs:dto.LunaCodeNode, rhs:dto.LunaCodeNode) : dto.LunaCodeNode{
        return this.logic(lhs,"!=",rhs);
    }
    gt(lhs:dto.LunaCodeNode, rhs:dto.LunaCodeNode) : dto.LunaCodeNode{
        return this.logic(lhs,">",rhs);
    }
    lt(lhs:dto.LunaCodeNode, rhs:dto.LunaCodeNode) : dto.LunaCodeNode{
        return this.logic(lhs,"<",rhs);
    }
    gte(lhs:dto.LunaCodeNode, rhs:dto.LunaCodeNode) : dto.LunaCodeNode{
        return this.logic(lhs,">=",rhs);
    }
    lte(lhs:dto.LunaCodeNode, rhs:dto.LunaCodeNode) : dto.LunaCodeNode{
        return this.logic(lhs,"<=",rhs);
    }
    or(lhs:dto.LunaCodeNode, rhs:dto.LunaCodeNode) : dto.LunaCodeNode{
        return this.logic(lhs,"||",rhs);
    }
    and(lhs:dto.LunaCodeNode, rhs:dto.LunaCodeNode) : dto.LunaCodeNode{
        return this.logic(lhs,"&&",rhs);
    }
    not(child:dto.LunaCodeNode):dto.NotNode{
        return {
            nodeType:dto.NodeKind.NotNode,
            child:child
        };
    }
    when(condition:dto.LunaCodeNode, result:dto.LunaCodeNode) : dto.WhenNode{
        return{
            nodeType:dto.NodeKind.WhenNode,
            condition : condition,
            result:result
        };
    }
    case(conditions:dto.WhenNode[], defaultValue:dto.LunaCodeNode) : dto.CaseNode{
        return {
            nodeType:dto.NodeKind.CaseNode,
            conditions:conditions,
            defaultValue : defaultValue
        };
    }
    if(condition:dto.LunaCodeNode, trueResult:dto.LunaCodeNode, falseResult:dto.LunaCodeNode): dto.IfNode{
        return{
            nodeType:dto.NodeKind.IfNode,
            condition:condition,
            trueResult:trueResult,
            falseResult:falseResult
        };
    }
    var(name:string):dto.VariableNode{
        return{
            nodeType:dto.NodeKind.VariableNode,
            name:name
        };
    }
    func(name:string, args:dto.LunaCodeNode[]):dto.FunctionNode{
        return{
            nodeType:dto.NodeKind.FunctionNode,
            name:name,
            parameterList:args
        };
    }
    in(expression:dto.LunaCodeNode, values:dto.LunaCodeNode[]):dto.InNode{
        return {
            nodeType:dto.NodeKind.InNode,
            expression:expression,
            parameterList:values
        };
    }
    isNull(expression:dto.LunaCodeNode):dto.IsNullNode{
        return{
            nodeType:dto.NodeKind.IsNullNode,
            lhs:expression
        };
    }
    isNotNull(expression:dto.LunaCodeNode):dto.LunaCodeNode{
        return this.not(this.isNull(expression));
    }
    like(expression:dto.LunaCodeNode, pattern:dto.LunaCodeNode){
        return {
            nodeType:dto.NodeKind.LikeNode,
            lhs:expression,
            rhs:pattern
        }
    };
    regexMatch(value:dto.LunaCodeNode, pattern:dto.LunaCodeNode): dto.FunctionNode {
        return this.func("RegexMatch",[value,pattern]);
    }
    
}